

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { BocciaturaConsegnaFase1 } from "src/app/models/dto/bocciaturaFase1.model";
import { BocciaturaConsegnaFase2 } from "src/app/models/dto/bocciaturaFase2.model";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";

  

@Component({
    selector: "app-verifica-consegna-fase2",
    templateUrl: "./dialog-verifica_consegna_fase2.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogVerificaConsegnaFase2 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;

    protected verificaVerbaleForm: FormGroup;
    protected verificaAllegatieForm: FormGroup;

    protected isVerificandoConsegna:boolean = false;
    
    protected pagineValidaConsegna: MenuItem[];
    protected activeIndex: number = 0;
    protected numeroPacchetti: number = 1000;
    selectAll: boolean = false; 

    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      private praticheService:PraticheService,
    ) {
      this.pratica          = this.config.data.pratica;
      if(this.pratica.bando==='BANDO 2'){
        this.numeroPacchetti = 1500;
      }
      this.verificaVerbaleForm = this.formBuilder.group({
        regione                 : [false],
        provincia               : [false],
        comune                  : [false],
        cui                     : [false],
        denominazione           : [false],
        indirizzo               : [false],
        coordinate              : [false],
        tipologiaEffettiva      : [false],
        correttezzaIPv4         : [false],
        coerenzaSpeedTest       : [false],
        coerenzaPingTest        : [false],
        backup                  : [false],
        wifi                    : [false],
        posizionamentoRouter    : [false],
        firmato                 : [false],
        coerenzaData            : [false],
        noteVerbale             : [null],
        selectAll               : [ false]  
      });
    
      this.verificaAllegatieForm = this.formBuilder.group({
        modemVisibile               : [ false],
        pingAlmeno1000Pacchetti     : [ false],
        speedTestRispettaRequisiti  : [ false],
        noteAllegati                : [ null],
        selectAll                   : [ false]  
       });
       
    }

    toggleAllFieldsFormAllegati(): void {
      this.logger.info("** toggleAllFieldsFormAllegati **");
      this.verificaAllegatieForm.setValue({
        modemVisibile:                this.verificaAllegatieForm.get('selectAll').value,
        pingAlmeno1000Pacchetti:      this.verificaAllegatieForm.get('selectAll').value,
        speedTestRispettaRequisiti:   this.verificaAllegatieForm.get('selectAll').value,
        noteAllegati:                 this.verificaAllegatieForm.get('noteAllegati').value,
        selectAll :                   this.verificaAllegatieForm.get('selectAll').value
      });
    }
    toggleAllFieldsFormVerbale(): void {
      this.logger.info("** toggleAllFieldsFormVerbale **");
      this.logger.info(this.verificaVerbaleForm.value);
      this.verificaVerbaleForm.setValue({

        regione:                    this.verificaVerbaleForm.get('selectAll').value,
        provincia:                  this.verificaVerbaleForm.get('selectAll').value,
        comune:                     this.verificaVerbaleForm.get('selectAll').value,
        cui:                        this.verificaVerbaleForm.get('selectAll').value,
        denominazione:              this.verificaVerbaleForm.get('selectAll').value,
        indirizzo:                  this.verificaVerbaleForm.get('selectAll').value,
        coordinate:                 this.verificaVerbaleForm.get('selectAll').value,
        tipologiaEffettiva:         this.verificaVerbaleForm.get('selectAll').value,
        correttezzaIPv4:            this.verificaVerbaleForm.get('selectAll').value,
        coerenzaSpeedTest:          this.verificaVerbaleForm.get('selectAll').value,
        coerenzaPingTest:           this.verificaVerbaleForm.get('selectAll').value,
        backup:                     this.verificaVerbaleForm.get('selectAll').value,
        wifi:                       this.verificaVerbaleForm.get('selectAll').value,
        posizionamentoRouter:       this.verificaVerbaleForm.get('selectAll').value,
        firmato:                    this.verificaVerbaleForm.get('selectAll').value,
        coerenzaData:               this.verificaVerbaleForm.get('selectAll').value,

        noteVerbale:                 this.verificaVerbaleForm.get('noteVerbale').value,
        selectAll :                  this.verificaVerbaleForm.get('selectAll').value
      });
     
    }
    ngOnInit(): void {
      this.inizializzaSteps();
    }

    inizializzaSteps() {
      this.pagineValidaConsegna = [
        {
          label: "Verbale di attivazione",
        },
        {
          label: "Allegati obbligatori",
        }
       ];
      this.activeIndex = 0;
    }

    checkNextStep(): boolean {
      let disableNextStepButton = false;
      if (this.activeIndex === this.pagineValidaConsegna.length - 1) {
        disableNextStepButton = true;
      }else if (this.activeIndex === 0 && !this.verificaVerbaleForm.valid) {
        disableNextStepButton = true;
      }else if (this.activeIndex === 1 && !this.verificaAllegatieForm.valid) {
        disableNextStepButton = true;
      }
      return disableNextStepButton;
    }

    changePage() {
      this.activeIndex = this.activeIndex + 1;
    
    }

   
    
    isVerbaleOK(): boolean {
      const formValues = this.verificaVerbaleForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') // Considera solo i booleani
        .every((key) => formValues[key] === true); // Verifica che siano true
    }
    geVerbaleKOFields(): string[] {
      const formValues = this.verificaVerbaleForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') 
        .filter((key) => formValues[key] === false); 
    }
    areAllegatiOK(): boolean {
      const formValues = this.verificaAllegatieForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') // Considera solo i booleani
        .every((key) => formValues[key] === true); // Verifica che siano true
    }
    geAllegatiKOFields(): string[] {
      const formValues = this.verificaAllegatieForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') 
        .filter((key) => formValues[key] === false); 
    }

    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isVerificandoConsegna = true;
        if( this.isVerbaleOK() && this.areAllegatiOK() ){
          //TUTTO OK VALIDO
           this.praticheService.presidioValidaConsegnaFase2(this.pratica.id).subscribe( {
            next: (v) => {
              this.isVerificandoConsegna = false;
              this.dialogRef.close({ success: true});
            },
            error: (e) => {
                this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di validazione della consegna della FASE 2 della pratica'});
                this.dialogRef.close({ success: false });
            },complete: () => {

            }
          }); 
        }else{
          let reportBocciaturaFase2:BocciaturaConsegnaFase2 = new BocciaturaConsegnaFase2();
          if(this.isVerbaleOK()){
            reportBocciaturaFase2.verbaleOK = true;
            
          }else{
            reportBocciaturaFase2.verbaleOK = false;
            reportBocciaturaFase2.noteVerbale = this.verificaVerbaleForm.value.noteVerbale;
            reportBocciaturaFase2.problemiVerbale = this.geVerbaleKOFields();
          }
         if(this.areAllegatiOK()){
            reportBocciaturaFase2.allegatiOK = true;
          }else{
            reportBocciaturaFase2.allegatiOK        = false;
            reportBocciaturaFase2.noteAllegati      = this.verificaAllegatieForm.value.noteAllegati;
            reportBocciaturaFase2.problemiAllegati  = this.geAllegatiKOFields();
          }
         
          this.logger.info(reportBocciaturaFase2);
           this.praticheService.presidioBocciaConsegnaFase2(this.pratica.id, reportBocciaturaFase2).subscribe( {
            next: (res) => {
              this.isVerificandoConsegna = false;
              this.dialogRef.close({ success: true});
            },  error: (e) => {
              this.isVerificandoConsegna = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Errore in fase di validazione della consegna di FASE 2!",
                });
              this.dialogRef.close({ success: false });
            },
            complete: () => {

            }
          } 
        );
        
        }
        
      } 
    }
  
  }